import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CxAbstractComponent } from '@b2b/components/cms/cx-abstract/cx-abstract-component/cx-abstract.component';
import { CmsComponentPipe } from '@app/b2b/core/cms/pipes/cms-component.pipe';
import { CmsComponent, CX_COMPONENT } from '@app/core/models/atomics.model';
import { B2BUnitService } from '@b2b/features/b2b-unit/core/b2b-unit.service';
import { TranslateModule } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { MenuMobileService } from '@core/services/menu-mobile.service';
import { IconHamburguerComponent } from '@b2b/components/cms/sections/cx-header-section/components/header-mobile/icon-hamburguer/icon-hamburguer.component';
import { UserService } from '@app/core/user/user.service';
import { Customer } from '@app/core/user/utilities/user.model';

@Component({
  selector: 'toggleable-menu',
  templateUrl: './toggleable-menu.component.html',
  styleUrl: './toggleable-menu.component.scss',
  imports: [
    CommonModule,
    RouterModule,
    IconHamburguerComponent,
    CxAbstractComponent,
    CmsComponentPipe,
    TranslateModule,
  ],
})
export class ToggleableMenuComponent {
  @Input({ required: true }) components!: CmsComponent[];

  CX_COMPONENT = CX_COMPONENT;

  status$ = this.menuMobileService.status();
  user$: Observable<Customer | null> = this.userService.get();

  // Get current B2B unit from store
  b2bUnit$ = this.b2bUnitService.getCurrentB2BUnit().pipe(map(state => state.data));

  constructor(
    private userService: UserService,
    private b2bUnitService: B2BUnitService,
    private menuMobileService: MenuMobileService,
  ) {}

  close() {
    this.menuMobileService.close();
  }
}
